import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  onClose: () => void;
  onReset: () => void;
}

/**
 * Display a message for a successfully submitted contact us form.
 */
export const ContactFormSuccess: FC<Props> = ({ onClose, onReset }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <WithGap gap="16" data-test="contact-us-form-success-message">
      <h3>{texts.pages.contactUs.success.title}</h3>

      <div className="font-body">
        {texts.pages.contactUs.success.description}
      </div>

      <WithGap gap="8" direction="row">
        <Button
          type="button"
          onClick={() => onClose()}
          data-test="close-contact-us-form"
          data-trackid={getTrackId(
            'close-contact-us-form',
            TrackingElement.Button,
          )}
        >
          {texts.pages.contactUs.close}
        </Button>

        <Button
          type="button"
          variant="subtle"
          onClick={() => onReset()}
          data-test="reset-contact-us-form"
          data-trackid={getTrackId(
            'reset-contact-us-form',
            TrackingElement.Button,
          )}
        >
          {texts.pages.contactUs.createNewMessage}
        </Button>
      </WithGap>
    </WithGap>
  );
};
